export const FIELDS = {
  EXPRESSION: "expression",
  SELECT: "select",
  REQUEST_BODY: "request_body",
  APPLY_RULES_SWITCH: "applyrules_switch",
  LIST: "list",
  FILES: "files",
  CHECKBOX: "checkbox",
  CUSTOM_FIELD_ARRAY: "custom_field_array",
  RADIO_GROUP: "radiogroup",
  INPUTS: "inputs",
  OUTPUTS: "outputs",
  TEXT: "text",
  TRANSACTIONS: "transactions",
  SELECT_FIELD: "select_field",
  NODE_DESCRIPTION: "nodeDescription",
  CODE_EDITOR: "code_editor",
  JS_CODE: "jsCode",
  MODEL_NAME: "modelName",
  OUTPUT_MODEL_TYPE: "outputModelType",
  MODEL_DEFINITION: "modelDefinition",
  RETURN_VALUE_MODEL: "Return value model",
  SELECT_CONNECTION: "select_connection",
  CUSTOM: "custom",
  PREDEFINED: "predefined",
  GROUP_BY: "group_by",
  ERROR_MANAGEMENT: "errorManagement",
  ASSIGN_INPUT: "assign_input",
  IF_FALSE: "ifFalse",
  IF_TRUE: "ifTrue",
  SMTP_CONNECTION: "smtpServerConnId",
  TEXT_MESSAGE: "text",
  HTML_MESSAGE: "html",
  PDF_MESSAGE: "pdfMessage",
  QUERY_PARAMS: "query_params",
  HTTP_HEADERS: "http_headers",
  OUTPUT_LINK_POINTS: "outputLinkPoints",
  DEFINE_MODEL: "define_model",
  MAPPER_MODEL: "mapper_modal",
  FIELD_UPDATES: "field_updates",
  UPDATES: "updates",
  COMPUTATION: "computation",
  SORTING: "sorting",
  TYPE: "type",
  SQL_EXPRESSION: "sqlExpression",
  APPLICATION_JSON: "applicationJson",
  SELECT_QUERY: "selectQuery",
  CUSTOM_MODEL: "custom_model",
  KEY_VALUE_PAIRS: "key_value_pairs",
  MODEL: "customModel",
  KEY_VALUES: "keyValues",
  LOGICAL: "Logical",
  OMITTED_FIELDS: "omitted_fields",
  CUSTOM_REQUEST: "custom request",
  APPLICATION_URLENCODED: "applicationURLEncoded",
  URL_ENCODED: "urlEncoded",
  APPLICATION_XML: "applicationXml",
  OBJECT_ID: "objectId",
  UPDATE_TYPE: "updateType",
  MULTI_COLLECTION: "multiCollection",
  MULTI_SELECT: "multiSelect",
  MULTI_ENTRY: "multiEntry",
  OUTPUT_FIELDS: "outputFields",
  MULTI_SELECT_DROPDOWN: "multiSelectDropdown",
  STRIPE_WEBHOOK_URL: "stripeWebhookUrl",
  STRIPE_WEBHOOK_ENABLED_EVENTS: "stripeWebhookEnabledEvents",
  RAZORPAY_PAYMENT_METHODS : "razorpayPaymentMethods",
  MAPPING_CONFIG: "mappingConfig",
  SUBFLOW: "subFlowName",
};

export const ACE_EDITOR_FIELDS = [
  FIELDS.SQL_EXPRESSION,
  FIELDS.APPLICATION_JSON,
  FIELDS.HTML_MESSAGE,
  FIELDS.TEXT_MESSAGE,
  FIELDS.APPLICATION_XML,
  FIELDS.JS_CODE,
  FIELDS.PDF_MESSAGE,
];

export const QUERY_PARAMETER_TYPES = [
  "text",
  "boolean",
  "integer",
  "decimal",
  "date-time",
  "email",
  "link",
  "identifier",
];

export const AGGREGATE_FUNCTIONS = [
  "Count",
  "Sum",
  "Average",
  "Maximum",
  "Minimum",
];

export const SORT_DIRECTION_OPTIONS = ["None", "Ascending", "Descending"];

export const QUERY_PARAMETER_COUNT = ["single", "multiple"];

export const CUSTOM = "custom";

export const START_NODE_NAME = "Start";

export const ROOT_NODE = {
  type: "resize",
  position: { x: 250, y: 5 },
  height: 58,
  width: 91,
  deletable: false,
};

export const UPDATE_TYPE = ["set", "unset"];

export const UNSET = "unset";
